import Text, { TextProps } from "../Text";

const TextTitle = (props: TextProps) => {
  return <Text {...props} fontSize={24} />;
};

export default TextTitle;
